<script>
import componentEditorMixin from '@/components/ProductComponents/CreateComponents/componentEditorMixin.js'
  export default {
    name: "circleEditor",
    mixins: [componentEditorMixin],
    data() {
      return {
        colorFlag: 0,
        borderStyleList: [
          {
            value: 'dotted',
            name: '点线'
          },
          {
            value: 'solid',
            name: '实线'
          },
          {
            value: 'dashed',
            name: '虚线'
          },
          {
            value: 'double',
            name: '双边'
          },
          {
            value: 'none',
            name: '无'
          },
        ],
        formList: [
          'CircleForm',
        ],
        ruleList: [
          {
            borderWidth:[
              {
                required: true,
                message: '请输入边框宽度'
              },
              {
                type: 'number',
                message: '边框宽度输入数字',
              }
            ]
          }
        ]
      }
    },
    computed: {
      specificForms() {
        return (
          <div class="specificForms">
              <el-collapse-item class="specificForm" title="圆形效果选项" name="2">
                <template slot="default">
                  <div class="specificForm">
                    <el-form id="CircleForm" props={{model: this.newSettings}} ref="CircleForm" label-style={this.formLabelStyle}>
                      <el-form-item label="填充颜色" prop="circleColor" label-position={this.labelPosition}>
                        <editor-field {...{attrs: {
                          value: this.newSettings.circleColor,
                          type: 'color',
                          varList: this.varList,
                          varJson: this.varJson,
                          showEditButton: true,
                            label:"填充颜色"
                          }}}{...{on: {
                            'input': val=>{
                              this.circleColorChange(val)
                              this.handleConfirmBtnClick()
                            }
                          }}}>
                        </editor-field>
                      </el-form-item>
                      <el-form-item label="边框类型" prop="borderStyle" label-position={this.labelPosition}>
                        <editor-field {...{attrs: {
                          value: this.newSettings.borderStyle,
                          type: 'radio',
                          radioList: this.borderStyleList,
                          varList: this.varList,
                          varJson: this.varJson,
                          showEditButton: false,
                            label:"边框类型"
                          }}}{...{on: {
                            'input': val=>{
                              this.borderStyleChange(val)
                              this.handleConfirmBtnClick()
                            }
                          }}}>
                        </editor-field>
                      </el-form-item>
                      <el-form-item label="边框颜色" prop="borderColor" label-position={this.labelPosition}>
                        <editor-field {...{attrs: {
                          value: this.newSettings.borderColor,
                          type: 'color',
                          varList: this.varList,
                          varJson: this.varJson,
                          showEditButton: true,
                            label:"边框颜色"
                          }}}{...{on: {
                            'input': val=>{
                              this.borderColorChange(val)
                              this.handleConfirmBtnClick()
                            }
                          }}}>
                        </editor-field>
                      </el-form-item>
                      <el-form-item label="边框宽度" prop="borderWidth" label-position={this.labelPosition}>
                        <editor-field {...{attrs: {
                          value: this.newSettings.borderWidth,
                          type: 'input',
                          varList: this.varList,
                          varJson: this.varJson,
                          showEditButton: true,
                            label:"边框宽度"
                          }}}{...{on: {
                            'input': val=>{
                              this.borderWidthChange(val)
                              this.handleConfirmBtnClick()
                            }
                          }}}>
                        </editor-field>
                      </el-form-item>
                      <el-form-item label="闪烁" prop="flash" label-position={this.labelPosition}>
                        <editor-field {...{attrs: {
                          value: this.newSettings.flash,
                          type: 'switch',
                          varList: this.varList,
                          varJson: this.varJson,
                        showEditButton: true,
                            label:"闪烁"
                          }}}{...{on: {
                            'input': val=>{
                              this.circleFlash(val)
                              this.handleConfirmBtnClick()
                            }
                          }}}>
                        </editor-field>
                      </el-form-item>
                    </el-form>
                  </div>
                </template>
              </el-collapse-item>
          </div>
        )
      }
    },
    methods:{
      circleColorChange(val){
        this.styleMergeObj = {
          ...this.styleMergeObj,
          'background-color': val
        }
        this.newSettings.circleColor = val
      },
      borderStyleChange(val){
        this.styleMergeObj = {
          ...this.styleMergeObj,
          'border-style': val
        }
        this.newSettings.borderStyle = val
      },
      borderColorChange(val){
        this.styleMergeObj = {
          ...this.styleMergeObj,
          'border-color': val
        }
        this.newSettings.borderColor = val
      },
      borderWidthChange(val){
        this.styleMergeObj = {
          ...this.styleMergeObj,
          'border-width': val + 'px'
        }
        this.newSettings.borderWidth = val
      },
      //圆形闪烁
      circleFlash(val){
        this.newSettings.flash = val
        if(val === true){
          this.styleMergeObj = {
            ...this.styleMergeObj,
            'animation-play-state' : 'running',
          }
        }
        else if(val === false){
          this.styleMergeObj = {
            ...this.styleMergeObj,
            'animation-play-state' : 'paused',
            // 'opacity': '100%',
          }
        }
      },
      circleState(val,attr){
        this.$set(this.newSettings, attr, val)
      },
      //圆形根据变量的变化
      circleChange(){

      }
    }
  }
  </script>

  <style lang="less">
  .circleEditor {
    .singleSelect {
      height: 30px;
      line-height: 30px;
      width: 100%;
      border-radius: 5px;
      padding: 0 10px;
    }
  }
  </style>

